<template>
  <lb-dialog
    v-model="internalValue"
    :heading="heading"
    :width="width"
    :loading="loading"
  >
    <template v-slot:body>
      <div>
        <div class="d-flex align-center">
          <v-btn color="primary" @click="$emit('generate')"><span>{{ generateLabel }}</span></v-btn>
          <v-spacer />
          <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                icon 
                color="primary" 
                class="ml-2" 
                v-bind="attrs"
                v-on="on"
                @click="$emit('refresh')"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Refresh list</span>
          </v-tooltip>
        </div>
        <lb-divider class="my-4" />
        <div v-if="!hasDownloads" class="title grey--text text--lighten-1 ma-4 text-center">{{ noDataMessage }}</div>
        <div v-else>
          <h5 class="mb-2 font-weight-regular">Previous downloads</h5>
          <div class="hoverable" v-for="entry in items" :key="entry._id">
            <div class="d-flex align-center px-2 py-1">
              <div class=" ml-2 grey--text" style="">
                Requested on: {{ $nova.formatDateTime(entry.created_at) }}
              </div>
              <v-spacer />
              <v-tooltip bottom content-class="tooltip-bottom" v-if="entry.stage === 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-0 px-0"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="$emit('download', entry._id)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span>
              </v-tooltip>
              <v-chip v-if="entry.stage === 1" color="primary" label><span>Ready</span></v-chip>
              <v-chip v-else-if="entry.stage === 0 || entry.stage === 4" color="primary-alt" label><span>Generating</span></v-chip>
              <div v-else>
                <v-chip color="error" label v-if="!entry.errormessage"><span>Failed</span></v-chip>
                <v-tooltip right content-class="tooltip-right" v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-3 px-0" icon v-on="on">
                      <v-chip color="error" label><span>Failed</span></v-chip>
                    </v-btn>
                  </template>
                  <span>{{ entry.errormessage }}</span>
                </v-tooltip>
              </div>
            </div>
            <lb-divider />
          </div>
        </div>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'PdfDownloadDialog',
  props: {
    value: { type: Boolean, default: false }, // CHANGED from modelValue
    heading: { type: String, default: 'Download PDF' },
    width: { type: [String, Number], default: 600 },
    loading: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    generateLabel: { type: String, default: 'Generate' },
    noDataMessage: { type: String, default: 'No downloads' },
  },
  emits: ['input', 'generate', 'download', 'refresh'], // CHANGED
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      }
    },
    hasDownloads() {
      return this.items && this.items.length > 0;
    }
  }
};
</script>